import React, { useContext } from 'react';
import { TComment, TUser } from '../../../models/common';
import styles from './comment.module.scss';
import { WStack, WTypography } from '../../wrappers/wrapper';
import { ArticleOwner } from '../article-owner/article-owner';
import CommentInput from '../comment-input/comment-input';
import helperService from '../../../services/helper.service';
import { UserContext } from 'contexts/userContext';

interface CommentProps {
  comment: TComment;
  mainComment?: TComment;
  isReplyInputVisible: boolean;
  onPost: (message: string) => void;
  onClickUser: (id: string) => void;
  onClickLike: (comment: TComment) => void;
  onDelete: () => void;
  onClickLikeCount: (comment: TComment) => void;
  onReply: (comment: TComment) => void;
}

const Comment: React.FC<CommentProps> = ({
  comment,
  mainComment,
  isReplyInputVisible,
  onPost,
  onClickUser,
  onClickLike,
  onDelete,
  onClickLikeCount,
  onReply,
}) => {
  const { user } = useContext(UserContext);

  const { liked } = helperService.getCommentIndexAndIsLiked(comment, user as TUser);

  const isOwner = (comment?.owner as TUser)?._id === user?._id;

  return (
    <WStack key={comment._id} className={styles.comment}>
      <ArticleOwner
        user={comment.owner as TUser}
        fromNowValue={comment.created_at}
        onClick={() => onClickUser((comment.owner as TUser)._id!)}
      />
      <WTypography className={styles.message}>{comment.message}</WTypography>
      <WStack className={styles['buttons']} direction="row" spacing={1}>
        <WTypography onClick={() => onClickLike(comment)}>{liked ? 'Liked' : 'Like'}</WTypography>
        <WTypography onClick={() => onReply(comment)}>Reply</WTypography>
        {isOwner && (
          <WTypography className={styles['delete']} onClick={onDelete}>
            Delete
          </WTypography>
        )}

        {comment.likes?.length! > 0 && (
          <WTypography className={styles['count']} onClick={() => onClickLikeCount(comment)}>
            {comment.likes?.length} Like
          </WTypography>
        )}
      </WStack>
      {isReplyInputVisible && <CommentInput comments={[comment, mainComment]} onPost={onPost} />}
    </WStack>
  );
};

export default Comment;
